module.exports = __webpack_public_path__ + "img/xiaochengxuma.eb7615c7.jpg";